export default __webpack_public_path__ + "locales/ar-SA/SmartBanner.json?hash=d76c175bf808b1c51d5b8732cd768328";